/// <amd-module name="Build/Admin/PoolsList/Stores/AgentQueueStore" />
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { Store } from "VSS/Reflux/Store";

import { TaskAgentQueueWrapper } from "Build/Admin/Common/Client/Contracts/DistributedTask/Wrappers";
import { TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentQueueStore extends Store {
    public state: TaskAgentQueue[] = [];

    constructor() {
        super("AgentQueueStoreChanged");
    }

    public getAgentQueueById(taskAgentQueueId: number): TaskAgentQueue | undefined {
        const matchingAgentQueues: TaskAgentQueue[] = this.state.filter(agentQueue => agentQueue.id === taskAgentQueueId);
        return matchingAgentQueues[0];
    }

    public updateAgentQueues = (agentQueues: TaskAgentQueueWrapper[]) => {
        this.state = this._sortQueues(agentQueues.slice(0));
        this.emitChanged();
    }

    public deleteAgentQueue = (agentQueue: TaskAgentQueue) => {
        this.state = this.state.filter(aq => aq.id !== agentQueue.id);
        this.emitChanged();
    }

    public addOrUpdateAgentQueue = (agentQueue: TaskAgentQueue) => {
        // If an existing queue with this ID exists, filter it out
        const allOtherQueues = this.state.filter(queue => queue.id !== agentQueue.id);

        // Now add the new object and re-sort
        this.state = this._sortQueues(allOtherQueues.concat([agentQueue]));
        this.emitChanged();
    }

    private _sortQueues(agents: TaskAgentQueue[]): TaskAgentQueue[] {
        return agents.sort((a: TaskAgentQueue, b: TaskAgentQueue) => {
            return localeIgnoreCaseComparer(a.name, b.name);
        });
    }
}
